import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Button, Tab, Tabs } from "@mui/material";
import "./index.scss";
import { isApprovedAllowed, isCreateAllowed } from "../../utils/common-utils";
import DocumentList from "./documents-list";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const LegalDocuments = ({ role }) => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const openTabIndex = searchParams.get("subIndex");
  const mainTabIndex = searchParams.get("index");
  const [value, setValue] = useState(+openTabIndex || 0);

  const handleChange = (event, newValue) => {
    setSearchParams({
      index: mainTabIndex || 0,
      subIndex: newValue
    });
    setValue(newValue);
  };

  return (
    <div className=' rm-pt po-list'>
      <div className='tabs-section'>
        <Box>
          <Tabs variant='scrollable' value={value} onChange={handleChange}>
            <Tab label='Open/Pending' />
            <Tab label='Approved' />
            <Tab label='All' />
            <Tab label='Rejected' />
            {isApprovedAllowed(role) && <Tab label='Pending With Me' />}
          </Tabs>
        </Box>
        <div className='left-container'>
          {isCreateAllowed(role) && (
            <Button
              variant='outlined'
              onClick={() => navigate("create-legal-document")}
            >
              Create Document
            </Button>
          )}
        </div>
      </div>
      <TabPanel value={value} index={0}>
        <DocumentList stage='openOrPending' />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <DocumentList stage='APPROVED' />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <DocumentList stage='all' />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <DocumentList stage='REJECTED' />
      </TabPanel>
      {isApprovedAllowed(role) && <TabPanel value={value} index={4}>
        <DocumentList stage='pendingWithRole' role={role} />
      </TabPanel>}
    </div>
  );
};

export default LegalDocuments;
